import { Message, MessageReply } from '../use-chat.types';

interface UpdateMessageProps {
  messages: Message[];
  message: Partial<Message>;
}

export const createNewMessage = (message: Partial<Message>): Message => {
  const {
    id = crypto.randomUUID(),
    question = '',
    status = 'pending',
    reply = [],
    hasSeen = false,
    type = 'alfred',
  } = message;

  return {
    id,
    question,
    status,
    reply,
    hasSeen,
    type,
  };
};

export const updateMessage = ({
  messages,
  message,
}: UpdateMessageProps): Message[] => {
  const existingMessageIndex = messages.findIndex(m => m.id === message.id);
  const updatedMessages = [...messages];
  updatedMessages[existingMessageIndex] = {
    ...updatedMessages[existingMessageIndex],
    ...message,
  };
  return updatedMessages;
};

export const appendReply = (
  messages: Message[],
  { id, reply }: { id: string; reply: MessageReply[] }
): Message[] => {
  return messages?.map(message => {
    if (message.id === id) {
      return { ...message, reply: [...message.reply, ...reply] };
    }

    return message;
  });
};
